module.exports = __webpack_public_path__ + "static/media/comments-reply.7743646c.svg";